<fieldset ngModelGroup="studyAccessInfoDetails">
  <!--header for existing study-->
  <div class="row" *ngIf="!(studyVM.study.studyId > 0)">
    <div class="col-6">
      <h5>Study Access</h5>
    </div>
    <div class="col-6">
      <div class="team-member">
        <i class="material-icons"> add_circle </i>
        <a href (click)="$event.preventDefault();addMemberShow = !addMemberShow" #addMember>Add Member</a>
      </div>
    </div>
  </div>

  <!--header for new study-->
  <div class="row" *ngIf="studyVM.study.studyId > 0">
    <div class="col-lg-12">
      <div class="team-member">
        <i class="material-icons"> add_circle </i>
        <a href (click)="$event.preventDefault(); addMemberShow = !addMemberShow" #addMember>Add Member</a>
      </div>
    </div>
  </div>

  <!--Add member section-->
  <div class="row" *ngIf="addMemberShow">
    <div class="col-12">
      <div class="form-group">
        <label class="team-member-label">Add New Team Member</label>
        <div class="inner-addon right-addon">
          <i class="material-icons inputgrp-icon"> search </i>
          <div class="form-group">
            <span class="ey-float-label">
              <p-autoComplete
                id="autocomplete-term"
                name="term"
                class="p-autocomplete"
                [(ngModel)]="term"
                [suggestions]="users"
                #trm="ngModel"
                (completeMethod)="filterUsers($event)"
                (onClear)="clearTextbox()"
                (onSelect)="selectedItem($event)"
                field="givenName"
                [size]="10"
                inputStyleClass="form-control team-member-input ey-field"
                [minLength]="2"
                appLabelFloat
              >
                <ng-template let-usr pTemplate="item">
                  <div class="d-inline-block pe-3 ps-2">
                    <i class="material-icons"> account_circle </i>
                  </div>
                  <div class="d-inline-block">
                    <span>{{ usr.givenName }} </span><span>{{ usr.surname }}</span>
                    <br />
                    <span>{{ getEmailAddress(usr) }}</span>
                  </div>
                </ng-template>
              </p-autoComplete>
              <label for="typeahead-format">Search EY Team Members</label>
            </span>
            <span class="help-block" *ngIf="userExistMessage.length > 0">
              {{ userExistMessage }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Display list of added users-->
  <div class="row">
    <div class="col-12">
      <ul class="list-group list-group-flush team-member-list" [ngClass]="{ 'has-error': validationMessage.length > 0 }">
        <li *ngFor="let usr of studyVM.userList; index as i">
          <div class="col-1 image">
            <i class="material-icons"> account_circle </i>
          </div>
          <div class="col-4 usrDetail" tabindex="0">
            <span class="name">{{ usr.user.preferredName }}</span>
            <span class="email-add">{{ usr.user.emailAddress }}</span>
            <span class="offc">{{ usr.user.officeLocation }}</span>
          </div>

          <div class="col-6 role display-data" *ngIf="usr.roleId === preparerRoleId">
            <div class="content">
              <label for="disp-access">Access Level </label>
              <span class="actualdata" tabindex="0">{{ preparerRole }}</span>
            </div>
          </div>
          <!--<div class="col-5 role" *ngIf="usr.user.activeDirectoryId !== currentUser?.id">
            <span class="ey-float-label">
              <select id="studyRoleId_{{usr.rowId}}" name="studyRoleId_{{usr.rowId}}" class="form-control" [(ngModel)]="usr.roleId" #studyRoleId appLabelFloat>
                <option [value]="undefined"></option>
                <option *ngFor="let role of roles" [ngValue]="role.roleId" [selected]="role.roleId === usr.roleId">{{role.roleName}}</option>
              </select>
              <label>Access Level</label>
            </span>
          </div>-->
          <div class="col-1 delete" *ngIf="usr.user.activeDirectoryId !== currentUser?.id">
            <i class="material-icons" (click)="removeSelectedItem(usr)" role="button" tabindex="0" (keydown)="onDeleteKeydown($event, usr)"> delete </i>
          </div>
        </li>
      </ul>

      <span class="help-block" *ngIf="validationMessage.length > 0">
        {{ validationMessage }}
      </span>
    </div>
  </div>
</fieldset>
